module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumb/legend.ac7b942.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumb/legend.jpg
// module id = Ntia
// module chunks = 0